import Nullstack from 'nullstack';
export default function IconAffiliate({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-affiliate",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5.931 6.936l1.275 4.249m5.607 5.609l4.251 1.275"
  }), "   ", Nullstack.element("path", {
    d: "M11.683 12.317l5.759 -5.759"
  }), "   ", Nullstack.element("circle", {
    cx: "5.5",
    cy: "5.5",
    r: "1.5"
  }), "   ", Nullstack.element("circle", {
    cx: "18.5",
    cy: "5.5",
    r: "1.5"
  }), "   ", Nullstack.element("circle", {
    cx: "18.5",
    cy: "18.5",
    r: "1.5"
  }), "   ", Nullstack.element("circle", {
    cx: "8.5",
    cy: "15.5",
    r: "4.5"
  }), " ");
}